$(document).ready(function() {

	// PRIVATE INTRO
	if ($('#private-intro').length > 0) {
		setTimeout(function(){
			$('#private-intro .inner').addClass('visible');
			$('.icon__thumbs--full').addClass('active');

			setTimeout(function(){
				$('#private-intro').fadeOut('fast', function(){
					$('#private-intro').remove();
				});
			}, 750);
		}, 500);
	}

});

// Resize
var lastWidth  = 0,
	lastHeight = 0;

function Resize() {
	lastWidth  = $(window).width();
	lastHeight = $(window).height();

	// Nav
	if ($('#works-nav').length > 0) {
		$('#works-nav .prev').css({'width':($('#works-nav .goto-top').offset().left)});
		$('#works-nav .next').css({'width':($('#works-nav .goto-top').offset().left+10)});
	}
}

$(document).ready(Resize());
$(window).resize(function(){ Resize(); });
document.addEventListener('webkitfullscreenchange', function(){ Resize(); }, false);
window.onorientationchange = function(){ var orientation = window.orientation; Resize(); }